import logo from '../../assets/imgs/logo_nectar.png';
import bg_gero_1 from '../../assets/imgs/nectar_banner.png';
import img_pt_00 from '../../assets/imgs/img_pt_00.jpg';

function Hero() {
    return (
        <header className='flex justify-center relative'>
            <img src={bg_gero_1} className="absolute w-full h-full z-0 user-select" style={{ objectFit: 'cover' }} alt='logo' />
            <div className='max-w-8xl flex items-center justify-center relative w-full pt-2 pb-12 px-5 lg:px-24'>
                <div className='z-10 w-full h-full'>
                    <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white rounded-lg md:hidden" aria-controls="navbar-default" aria-expanded="false">
                        <span className="sr-only">Open main menu</span>
                        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path fill='#FFF' stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
                        </svg>
                    </button>

                    <div className='flex items-center justify-center mt-16'>
                        <img src={logo} alt="logo" className='w-40' />
                    </div>

                    <div className='w-full text-right'>
                        <div className='w-full text-center mt-8 md:mt-8'>
                            <h1 className='text-5xl text-white pb-1 uppercase border-b gradient-border-b text-left'>EFECTO NOCEBO, FACTORES COGNITIVOS Y ADHERENCIA TERAPEUTICA EN ENFERMEDADES REUMATICAS (NECTAR)</h1>
                            <p className='text-white mt-8 text-2xl text-left' style={{ fontWeight: 100 }}>
                                Un elevado porcentaje de los pacientes con enfermedades reumáticas tiene falta de adherencia a sus tratamientos, con un impacto significativo en la eficacia de los mismo, en los costes sanitarios y en la calidad de vida de los pacientes. El efecto nocebo, entre otros factores, puede tener un importante papel en la falta de adherencia intencional.
                            </p>
                            <p className='text-white mt-8 text-2xl text-left' style={{ fontWeight: 100 }}>
                                El objetivo del estudio es proporcionar un mejor conocimiento de los factores relacionados con la falta de adherencia, especialmente los asociados con variables psicológicas poco estudiadas. Con este proyecto tratamos de identificar y/o medir aquellos factores sociodemográficos, clínicos, cognitivos y emocionales que pueden asociarse a menor adherencia a los tratamientos.
                            </p>
                            <p className='text-white mt-8 text-2xl text-left' style={{ fontWeight: 100 }}>
                                Proyecto PID2022-141949NB-I00 financiado por:
                            </p>
                            <img src={img_pt_00} alt='Fondo europeo de desarrollo regional' className='w-1/3'/>
                        </div>
                    </div>

                </div>
            </div>
        </header>
    );
}

export default Hero;